export default __webpack_public_path__ + "static/social-mockup-3b3d15267071d65ebb87df8db9bb6082.png";